export default (obj => obj && obj.__isYupSchema__);


//////////////////
// WEBPACK FOOTER
// ../node_modules/yup/es/util/isSchema.js
// module id = 386
// module chunks = 0